module.exports = __webpack_public_path__ + "static/media/sports-questions.bead57a9.csv";